import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { cn } from '../lib/utils';
import { Button } from './ui/button';
import { ArrowRight, Coins } from 'lucide-react';

export default function CTASection({ onGetStarted }) {
  const [ref, visible] = useScrollAnimation();

  return (
    <section ref={ref} className={cn('py-24 bg-gradient-cta overflow-hidden relative reveal', visible && 'revealed')}>
      {/* Background decoration */}
      <div className='absolute inset-0 dot-pattern-hero opacity-50 pointer-events-none' />
      <div className='absolute top-1/4 left-1/4 w-72 h-72 bg-accent/10 rounded-full blur-3xl pointer-events-none' />
      <div className='absolute bottom-1/4 right-1/4 w-56 h-56 bg-primary-light/15 rounded-full blur-3xl pointer-events-none' />

      <div className='max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10'>
        {/* Badge */}
        <div className='inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-foreground/12 border border-primary-foreground/20 text-accent-light text-sm font-medium mb-8'>
          <Coins className='w-4 h-4' />
          10 bonus credits — no credit card required
        </div>

        <h2 className='font-heading font-bold text-4xl sm:text-5xl lg:text-6xl text-primary-foreground mb-6 leading-tight'>
          Start extracting fields
          <br />
          <span className='text-accent-light'>from invoices, for free</span>
        </h2>

        <p className='text-primary-foreground/70 text-lg leading-relaxed max-w-2xl mx-auto mb-10'>
          Register in seconds, get 10 bonus credits, and call the API immediately.
          No credit card, no cloud AI — all processing stays on our server.
        </p>

        <div className='flex flex-col sm:flex-row gap-4 justify-center'>
          <Button
            variant='accent'
            size='xl'
            onClick={onGetStarted}
            className='shadow-accent gap-2'
          >
            Get Started Free
            <ArrowRight className='w-5 h-5' />
          </Button>
          <Button
            variant='hero'
            size='xl'
            onClick={() => {
              const el = document.getElementById('pricing');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            View Pricing
          </Button>
        </div>

        {/* Trust badges */}
        <div className='flex flex-wrap items-center justify-center gap-6 mt-12'>
          {['No Cloud AI', 'Privacy-First', 'Data Not Stored', 'Fully Self-Hosted'].map((b) => (
            <div key={b} className='flex items-center gap-1.5 text-primary-foreground/55 text-xs font-medium'>
              <div className='w-1.5 h-1.5 rounded-full bg-accent' />
              {b}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
